import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

class FancyBox {
    constructor(){
        Fancybox.bind("[data-fancybox]", {
            // Your custom options
        });
    }
}

export default FancyBox